import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import DatasetCards from '../components/DatasetCards';
import DatasetsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DatasetsPanelContainer';
import DatasetsFilters from './DatasetsFilters';
import DatasetsDataModelFilter from '../datamodels/components/DatasetsDataModelFilter';

const DatasetsPanelNarrow = ({
  allowDataModelRead,
  allowMultiSelect,
  canCreate,
  canRead,
  category,
  currentPage,
  datasets,
  fetchData,
  newDatasetCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(datasets, { pageSize, total }));
  return (
    <DatasetsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-datasets-panel-narrow">
      <div className="sticky-panel-header">
        <DatasetsFilters category={category} className="aridhia-list-filter" fluid />
        { allowDataModelRead && <DatasetsDataModelFilter category={category} className="mt-5" fluid /> }
      </div>
      <DatasetCards
        canCreate={canCreate}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={datasets}
        itemsPerRow={1}
        newDatasetCode={newDatasetCode}
        onCheckBoxClick={allowMultiSelect ? (value) => onCheckBoxClick(category, value) : undefined}
        readErrors={readErrors}
        readStatus={readStatus}
        showStatus
        showTools
      />
    </DatasetsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetsPanelNarrow);
